import { Button } from "@/components/ui/button";
const timeline = [{
  year: "",
  title: "Presença constante na Caatinga",
  description: "Equipes visitam regularmente comunidades sertanejas com evangelho, discipulado e cuidado integral."
}, {
  year: "",
  title: "Lares e igrejas alcançadas",
  description: "Parcerias com igrejas locais fortalecem a fé e o serviço em dezenas de vilarejos espalhados pelo semiárido."
}, {
  year: "",
  title: "Sementes de esperança",
  description: "Oração, escuta, palavra e presença geram conexões profundas com famílias em situação de vulnerabilidade."
}];
const metrics = [{
  label: "Comunidades acompanhadas",
  value: "10+"
}, {
  label: "Viagens missionárias já realizadas",
  value: "10+"
}, {
  label: "Voluntários envolvidos",
  value: "80+"
}];
const HomeMissoesCaatingaHighlight = () => {
  return <section className="section-shell">
      <div className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="section-title">Projeto em destaque</p>
          <h2 className="section-heading">Missões Caatinga em profundidade.</h2>
          <p className="section-subtitle">
            Um olhar mais próximo para a frente missionária que pulsa no sertão nordestino, unindo evangelização,
            cuidado social e presença constante.
          </p>
        </div>
        <Button asChild className="btn-pill-lg hero-orbit hover-lift text-primary-foreground shadow-lg hover:brightness-110">
          <a href="https://www.instagram.com/iessa.instituto/" target="_blank" rel="noreferrer">
            Conheça nossa missão
          </a>
        </Button>
      </div>

      <div className="grid gap-10 lg:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)] lg:items-start">
        {/* Linha do tempo */}
        <div className="relative space-y-6 animate-fade-in">
          <div className="absolute left-[11px] top-3 bottom-3 hidden bg-gradient-to-b from-primary/70 via-secondary/70 to-primary/40 md:block" />
          <div className="space-y-6">
            {timeline.map((item, index) => <div key={item.title} className={`relative flex gap-4 md:gap-6 parallax-card ${index === 0 ? "anim-delay-1" : index === 1 ? "anim-delay-2" : "anim-delay-3"}`}>
                <div className="relative mt-1 flex flex-col items-center">
                  <div className="z-10 flex h-6 w-6 items-center justify-center rounded-full bg-primary text-[10px] font-semibold text-primary-foreground shadow-md">
                    {item.year}
                  </div>
                  <div className="mt-2 hidden h-full w-px bg-primary/20 md:block" />
                </div>
                <div className="card-ambient hover-lift w-full p-4 sm:p-5">
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-secondary">{item.title}</p>
                  <p className="mt-2 text-sm text-muted-foreground">{item.description}</p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Métricas ilustrativas */}
        <aside className="space-y-6 rounded-2xl bg-accent/60 p-6 shadow-[0_24px_60px_rgba(15,23,42,0.18)] animate-fade-in anim-delay-2">
          
          

          <div className="grid gap-4 sm:grid-cols-3">
            {metrics.map((metric, index) => <div key={metric.label} className={`rounded-2xl border border-primary/10 bg-card/90 p-4 text-center hover-lift parallax-card ${index === 0 ? "anim-delay-1" : index === 1 ? "anim-delay-2" : "anim-delay-3"}`}>
                <p className="text-2xl font-semibold text-primary">{metric.value}</p>
                <p className="mt-1 text-xs text-muted-foreground">{metric.label}</p>
              </div>)}
          </div>
        </aside>
      </div>
    </section>;
};
export default HomeMissoesCaatingaHighlight;